// extracted by mini-css-extract-plugin
export default {"integration-menu":"style_integration-menu__xh1y5","menu-popover":"style_menu-popover__ulKbz","button-action-icon":"style_button-action-icon__G6ord"};